<template>
    <div>
        <close-requests></close-requests>

        <h5 class="font-weight-bold">My Requests</h5>

        <div class="d-flex mb-3 requests-top" style="column-gap: 10px">
            <div class="flex-fill">
                <form @submit.prevent="loadRequests()" class="search-form">
                    <div class="input-group">
                        <input type="search" class="form-control form-control-lg mr-3" v-model="search"
                               style="border-radius: 20px;"
                               placeholder="Search by request code or title" autofocus>
                        <div class="input-group-append">
                            <button class="btn btn-secondary" type="submit">Search</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="requests-top-buttons">
                <router-link to="/requests/precreate" class="btn btn-secondary">Create Request</router-link>&nbsp;
            </div>
        </div>

        <alerts :_error="error" :_success="success"></alerts>

<!--        <div class="mb-3 d-flex align-items-center justify-content-between bg-white p-3 shadow-sm rounded"-->
<!--             style="gap: 20px">-->
<!--            <div class="form-group flex-fill">-->
<!--                <label>With the selected</label>-->
<!--                <select class="form-control">-->
<!--                    <option>Verify</option>-->
<!--                    <option>Disburse</option>-->
<!--                    <option>Close</option>-->
<!--                </select>-->
<!--            </div>-->

<!--            <div class="form-group flex-fill">-->
<!--                <label>Filter Status</label>-->
<!--                <select class="form-control">-->
<!--                    <option value="authorized">Authorized</option>-->
<!--                    <option value="approved">Approved</option>-->
<!--                    <option value="verified">Verified</option>-->
<!--                    <option value="disbursed">Disbursed</option>-->
<!--                </select>-->
<!--            </div>-->

<!--            <div class="form-group text-right">-->
<!--                <label>&nbsp;</label>-->
<!--                <div class="custom-control custom-switch">-->
<!--                    <input type="checkbox" class="custom-control-input" id="switch1">-->
<!--                    <label class="custom-control-label" for="switch1">Show Closed</label>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <table class="table bg-white shadow-sm">-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th>-->
<!--                    <div class="custom-control custom-switch">-->
<!--                        <input type="checkbox" class="custom-control-input" id="select_all">-->
<!--                        <label class="custom-control-label" for="select_all"></label>-->
<!--                    </div>-->
<!--                </th>-->
<!--                <th>CODE</th>-->
<!--                <th class="w-75">REQUEST</th>-->
<!--                <th>STATUS</th>-->
<!--                <th>AMOUNT</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr v-for="request in requests.data" :key="request.code">-->
<!--                <td>-->
<!--                    <div class="custom-control custom-switch">-->
<!--                        <input type="checkbox" class="custom-control-input" :id="request.code">-->
<!--                        <label class="custom-control-label" :for="request.code"></label>-->
<!--                    </div>-->
<!--                </td>-->
<!--                <td class="font-weight-bold">{{ request.code }}</td>-->
<!--                <td>-->
<!--                    <div class="d-flex">-->
<!--                        <div class="mr-2">-->
<!--                            <img :src="request.user.avatar" class="rounded-circle mb-2 p-1 border d-block"-->
<!--                                 style="height: 48px; border-color: #42B4FF!important;">-->
<!--                        </div>-->
<!--                        <div class="flex-fill">-->
<!--                            {{ request.title }} <br>-->
<!--                            <small class="text-muted">{{-->
<!--                                    day(request.created_at).format('MMM, DD YYYY H:mm A')-->
<!--                                }}</small>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </td>-->
<!--                <td><span :class="'status ' + request.status">{{ request.status }}</span></td>-->
<!--                <td class="font text-right">{{ request.amount }}</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->

        <section v-if="wait">
            <placeholder></placeholder>
        </section>

        <div v-else v-for="request in requests.data" :key="request.id"
             class="bg-white mb-3 shadow-sm rounded-lg">
            <router-link :to="'/requests/'+request.code + '?page='+ current_page" style="color: inherit;">
                <div class="d-flex request">
                    <div class="request-profile p-3 pt-md-4 text-center">
                        <img :src="request.user.avatar" class="rounded-circle mb-2 p-1 border d-block"
                             style="height: 70px; border-color: #42B4FF!important;">
                    </div>
                    <div class="p-3 flex-fill">
                        <h5 class="font-weight-bold">
                            {{ request.user.name }}
                            <span class="text-danger" v-if="request.is_draft">(Draft)</span>
                        </h5>

                        <div class="narration mb-1">
                            {{ request.title }}
                            <sup v-if="request.type=='card'" class="badge badge-secondary"><i>Card</i></sup>
                            <sup v-if="request.type=='advance'" class="badge small badge-warning"><i>Advance</i></sup>
                        </div>

                        <div class="mb-2 small text-muted">
                            {{ day(request.created_at).format('MMM, DD YYYY H:mm A') }}
                        </div>

                        <stage class="mb-3" :request="request"></stage>

                        <div class="d-flex" style="column-gap: 20px;">
                            <div>
                                <span :class="'status ' + request.status">{{ request.status }}</span>&nbsp;
                            </div>
                            <div>
                                <ion-icon :name="'chatbubbles-outline'"
                                          style="vertical-align:middle;color:#aaa;font-size: 20px;"></ion-icon>
                                <sup>{{ request.comments_count }}</sup>
                            </div>
                            <div class="text-muted">
                                <ion-icon :name="'document-attach-outline'"
                                          style="vertical-align:middle;color:#aaa;font-size: 20px;"></ion-icon>
                                <sup>{{ request.documents_count }}</sup>
                            </div>
                            <div v-if="request.budgeted_at" class="text-muted" title="Budgeting">
                                <ion-icon :name="'checkmark-circle-outline'"
                                          style="vertical-align:middle;color:#aaa;font-size: 20px;color: green"></ion-icon>
                            </div>

                            <div>
                                <tagged :request="request"></tagged>
                            </div>
                        </div>
                    </div>

                    <div class="p-3 pt-md-5 flex-fill ml-md-auto text-md-right request-amount">
                        <h6 class="font-weight-bold text-muted">{{ request.code }}</h6>
                        <h6 class="small text-muted">{{ request.currency }}</h6>
                        <h5 class="font"><u>{{ request.amount }}</u></h5>
                    </div>
                </div>
            </router-link>
        </div>

        <br>
        <pagination :data="requests" @pagination-change-page="loadRequests" :limit="1"></pagination>
        <div class="clearfix"></div>

    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Tagged from "./helpers/Tagged";
import Stage from "./Stage";
import CloseRequests from "@/components/CloseRequests.vue";
import Placeholder from "@/components/helpers/Placeholder.vue";

export default {
    name: "Requests",
    props: ['auth'],
    components: {Placeholder, CloseRequests, Stage, Tagged, Alerts},
    data() {
        return {
            requests: {data: [], total: 0},
            search: '',
            status: [],
            statuses: [],
            current_page: 1
        }
    },
    mounted() {
        const page = this.getCurrentPage()
        this.loadRequests(page)
    },
    watch: {
        search(a) {
            if (!a || a.length >= 3) {
                this.loadRequests()
            }
        },
        '$route.query.page'(newPage) {
            const page = newPage ? parseInt(newPage) : 1
            this.loadRequests(page)
        }
    },
    methods: {
        getCurrentPage() {
            return this.$route.query.page ? parseInt(this.$route.query.page) : 1
        },
        loadStatuses() {
            this.$http.get('request/statuses').then(response => {
                this.statuses = response.data.data
            })
        },
        loadRequests(page = 1) {
            window.scroll(0, 0)
            this.wait = true
            this.clear()

            this.$http.get('requests?search=' + this.search + '&status=' + this.status + '&page=' + page).then(response => {
                this.requests = response.data.data
                this.success = this.error = ''
                this.current_page = page

                const currentPage = this.getCurrentPage()
                console.log(currentPage)
                if (currentPage !== page) {
                    this.$router.push({path: '/requests', query: {page}})
                }
            }).catch(err => {
                this.showError(err)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<style scoped>
@keyframes blink {
    0% {
        opacity: 0.6;
    }
    50% {
        opacity: 0.9;
    }
    100% {
        opacity: 0.6;
    }
}

.blink {
    animation: blink 1.5s infinite;
}

.stages-helper {
    width: 50%;
}

@media only screen and (max-width: 480px) {
    .shadow {
        box-shadow: none !important;
    }

    .p-4 {
        padding: 10px !important;
    }

    .stages-helper {
        gap: 12px !important;
        flex-wrap: wrap;
    }
}
</style>